var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brow-layout",on:{"click":_vm.closeVideo}},[_c('div',{staticClass:"con",on:{"click":function($event){$event.stopPropagation();}}},[_c('video',{attrs:{"src":(_vm.$cdn + "course/videos/" + _vm.url + ".mp4"),"autoplay":"","controls":"","loop":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-622a723a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/browseVideo/index.vue
// module id = null
// module chunks = 